import moment from "moment"
import { Brand } from "./helpers"

const ISO_DATE_FORMAT = "YYYY-MM-DD"

export type IsoDate = Brand<string, "IsoDate">

export function assertIsoDate(isoDate: unknown): asserts isoDate is IsoDate {
  if (typeof isoDate !== "string" || !moment(isoDate, ISO_DATE_FORMAT, true).isValid()) {
    throw Error(`Invalid ISO Date: ${isoDate}`)
  }
}

export function getToday(): IsoDate {
  return moment().format("YYYY-MM-DD") as IsoDate
}

export type IsoTime = Brand<string, "IsoTime">

export type Timestamp = number | string
